import { createStyles, type WithStyles, withStyles } from "@material-ui/core";
import history from "features/app/History";
import PageTitle from "features/collect/supplementation/views/shared/pageTitle";
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import type { RootState } from "redux/reducers";
import { deselecionarPasto } from "../../../../redux/actions/pastoActions";
import PastureRegistrations from "./PastureRegistrations";
import { PortalRoutes } from "constants/routes";
import { useTranslations } from "adapters/i18n";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type OwnProps = unknown;

type PastureRegistrationsContainerProps = OwnProps &
  StateProps &
  DispatchProps &
  WithStyles<typeof styles>;

function PastureRegistrationsContainer({
  classes,
  forages,
  isPastureModified,
  newPasturesCoords,
  pastureErrors,
  primePastures,
  retreats,
  selectedFarmId,
  selectedPasture,
  selectedRetreatId,
  toggles,
  trough,
  troughErrors,
  unselectPasture,
}: PastureRegistrationsContainerProps) {
  const isEdit =
    history.location.pathname.includes("editar") ||
    selectedPasture?.IdPasto != null;

  const { t } = useTranslations();

  const [newPasture, setNewPasture] = useState(selectedPasture);
  const [targetTrough, setTargetTrough] = useState(trough);
  const [creepTrough, setCreepTrough] = useState();

  const onGoBack = useCallback(() => {
    unselectPasture();
    history.replace(PortalRoutes.PASTURE_REGISTRATIONS);
  }, [unselectPasture]);

  useEffect(() => {
    const handleEscKeyPressed = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isEdit) {
        onGoBack();
      }
    };

    window.addEventListener("keydown", handleEscKeyPressed);
    return () => window.removeEventListener("keydown", handleEscKeyPressed);
  }, [isEdit, onGoBack]);

  const pageTitle = isEdit
    ? t("pasture:edit-pasture")
    : t("pasture:new-pasture");

  return (
    <>
      <PageTitle
        containerClass={classes.pageTitleContainer}
        titleClass={classes.pageTitle}
        title={pageTitle}
        onGoBack={onGoBack}
      />
      <div className={classes.formWrapper}>
        <PastureRegistrations
          AreaNovoPasto={selectedPasture.AreaNovoPasto}
          cadastroPastoModificado={isPastureModified}
          Cocho={targetTrough}
          CoordenadasNovosPastos={newPasturesCoords}
          creepTrough={creepTrough}
          errosCocho={troughErrors}
          errosPasto={pastureErrors}
          Forragens={forages}
          id="containerCadastro"
          IdFazenda={selectedFarmId}
          IdRetiro={selectedRetreatId}
          isEdit={isEdit}
          PastoSelecionado={selectedPasture}
          PastosPrime={primePastures}
          pasture={newPasture}
          Retiros={retreats}
          setCreepTrough={setCreepTrough}
          setPasture={setNewPasture}
          setTrough={setTargetTrough}
          showTroughForm={true}
          Toggles={toggles}
          trough={targetTrough}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state: RootState) => ({
  forages: state.forragem.Forragens,
  // @ts-expect-error - pasto reducer not typed yet
  isPastureModified: state.pasto.cadastroPastoModificado,
  // @ts-expect-error - pasto reducer not typed yet
  newPastureArea: state.pasto.AreaNovoPasto,
  // @ts-expect-error - pasto reducer not typed yet
  newPasturesCoords: state.pasto.CoordenadasNovoPasto,
  // @ts-expect-error - pasto reducer not typed yet
  pastureErrors: state.pasto.erros,
  primePastures: state.pastosPrime.PastosPrime,
  // @ts-expect-error - retiro reducer not typed yet
  retreats: state.retiro.Retiros,
  selectedFarmId: state.fazenda.FazendaSelecionada,
  // @ts-expect-error - pasto reducer not typed yet
  selectedPasture: state.pasto.PastoSelecionado,
  // @ts-expect-error - retiro reducer not typed yet
  selectedRetreatId: state.retiro.RetiroSelecionado,
  toggles: state.fazenda.Toggles,
  trough: state.cocho.Cocho,
  troughErrors: state.cocho.erros,
});

const mapDispatchToProps = {
  unselectPasture: deselecionarPasto,
};

const styles = () =>
  createStyles({
    pageTitleContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: 32,
      marginStart: 40,
      marginEnd: 40,
      marginBottom: 0,
    },
    pageTitle: {
      margin: 0,
      fontSize: 18,
      fontWeight: "normal",
    },
    formWrapper: {
      height: "95%",
      width: "100%",
      padding: "32px 40px 0px 40px",
    },
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(PastureRegistrationsContainer));
